import { Directive } from '@angular/core';

@Directive({
  selector: '[irisHeaderSearchResultCardPrimaryIcon]',
  standalone: false,
})
export class IrisHeaderSearchResultCardPrimaryIconDirective {
}
